// Types pour l'authentification
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT = "LOGOUT";


// Type d'actions pour la création d'utilisateur
export const CREATE_UTILISATEUR_REQUEST = "CREATE_UTILISATEUR_REQUEST";
export const CREATE_UTILISATEUR_SUCCESS = "CREATE_UTILISATEUR_SUCCESS";
export const CREATE_UTILISATEUR_FAILURE = "CREATE_UTILISATEUR_FAILURE";

// Type d'actions pour la liste des utilisateurs
export const FETCH_UTILISATEURS_REQUEST = "FETCH_UTILISATEURS_REQUEST";
export const FETCH_UTILISATEURS_SUCCESS = "FETCH_UTILISATEURS_SUCCESS";
export const FETCH_UTILISATEURS_FAILURE = "FETCH_UTILISATEURS_FAILURE";

// Type d'actions pour update utilisateur
export const UPDATE_UTILISATEUR_REQUEST = "UPDATE_UTILISATEUR_REQUEST";
export const UPDATE_UTILISATEUR_SUCCESS = "UPDATE_UTILISATEUR_SUCCESS";
export const UPDATE_UTILISATEUR_FAILURE = "UPDATE_UTILISATEUR_FAILURE";

// Type d'actions pour update password
export const UPDATE_UTILISATEUR_PASSWORD_REQUEST = "UPDATE_UTILISATEUR_PASSWORD_REQUEST";
export const UPDATE_UTILISATEUR_PASSWORD_SUCCESS = "UPDATE_UTILISATEUR_PASSWORD_SUCCESS";
export const UPDATE_UTILISATEUR_PASSWORD_FAILURE = "UPDATE_UTILISATEUR_PASSWORD_FAILURE";

// type d'actions pour forgot password
export const FORGOT_PASSWORD_REQUEST = "FORGOT_PASSWORD_REQUEST";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = "FORGOT_PASSWORD_FAILURE";

// type d'actions pour reset password
export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

// type d'actions pour la création de formulaire
export const CREATE_FORMULAIRE_REQUEST = "CREATE_FORMULAIRE_REQUEST";
export const CREATE_FORMULAIRE_SUCCESS = "CREATE_FORMULAIRE_SUCCESS";
export const CREATE_FORMULAIRE_FAILURE = "CREATE_FORMULAIRE_FAILURE";

// Type d'actions pour la liste des formulaires
export const FETCH_FORMULAIRES_REQUEST = "FETCH_FORMULAIRES_REQUEST";
export const FETCH_FORMULAIRES_SUCCESS = "FETCH_FORMULAIRES_SUCCESS";
export const FETCH_FORMULAIRES_FAILURE = "FETCH_FORMULAIRES_FAILURE";

// Type d'actions pour l'update dun formulaire
export const UPDATE_FORM_REQUEST = "UPDATE_FORM_REQUEST";
export const UPDATE_FORM_SUCCESS = "UPDATE_FORM_SUCCESS";
export const UPDATE_FORM_FAILURE = "UPDATE_FORM_FAILURE";

// Type d'actions pour le publish form
// Types.js
export const PUBLISH_FORM_REQUEST = "PUBLISH_FORM_REQUEST";
export const PUBLISH_FORM_SUCCESS = "PUBLISH_FORM_SUCCESS";
export const PUBLISH_FORM_FAILURE = "PUBLISH_FORM_FAILURE";

// Type pour activer ou désactiver un utilisateur 
export const TOGGLE_USER_STATUS_REQUEST = "TOGGLE_USER_STATUS_REQUEST";
export const TOGGLE_USER_STATUS_SUCCESS = "TOGGLE_USER_STATUS_SUCCESS";
export const TOGGLE_USER_STATUS_FAILURE = "TOGGLE_USER_STATUS_FAILURE";

// Type pour les statistics 
export const FETCH_STATISTICS_REQUEST = "FETCH_STATISTICS_REQUEST";
export const FETCH_STATISTICS_SUCCESS = "FETCH_STATISTICS_SUCCESS";
export const FETCH_STATISTICS_FAILURE = "FETCH_STATISTICS_FAILURE";

// Type pour le journal d'audit
export const FETCH_AUDIT_LOGS_REQUEST = "FETCH_AUDIT_LOGS_REQUEST";
export const FETCH_AUDIT_LOGS_SUCCESS = "FETCH_AUDIT_LOGS_SUCCESS";
export const FETCH_AUDIT_LOGS_FAILURE = "FETCH_AUDIT_LOGS_FAILURE";

// Types pour fermer les réponses
export const LIMIT_REPONSE_REQUEST = "LIMIT_REPONSE_REQUEST";
export const LIMIT_REPONSE_SUCCESS = "LIMIT_REPONSE_SUCCESS";
export const LIMIT_REPONSE_FAILURE = "LIMIT_REPONSE_FAILURE";


// Types partager formulaire
export const PARTAGE_FORM_REQUEST = "PARTAGE_FORM_REQUEST";
export const PARTAGE_FORM_SUCCESS = "PARTAGE_FORM_SUCCESS";
export const PARTAGE_FORM_FAILURE = "PARTAGE_FORM_FAILURE";

// Type obtenir un formulaire par son id
export const GET_FORM_BY_ID_REQUEST = "GET_FORM_BY_ID_REQUEST";
export const GET_FORM_BY_ID_SUCCESS = "GET_FORM_BY_ID_SUCCESS";
export const GET_FORM_BY_ID_FAILURE = "GET_FORM_BY_ID_FAILURE";

// Types pour la création de réponse
export const CREATE_RESPONSE_REQUEST = "CREATE_RESPONSE_REQUEST";
export const CREATE_RESPONSE_SUCCESS = "CREATE_RESPONSE_SUCCESS";
export const CREATE_RESPONSE_FAILURE = "CREATE_RESPONSE_FAILURE";

export const FETCH_RESPONSES_REQUEST  = "FETCH_RESPONSES_REQUEST";
export const FETCH_RESPONSES_SUCCESS  = "FETCH_RESPONSES_SUCCESS";
export const FETCH_RESPONSES_FAILURE  = "FETCH_RESPONSES_FAILURE";

// 
export const FETCH_GROUPED_RESPONSES_REQUEST = "FETCH_GROUPED_RESPONSES_REQUEST";
export const FETCH_GROUPED_RESPONSES_SUCCESS = "FETCH_GROUPED_RESPONSES_SUCCESS";
export const FETCH_GROUPED_RESPONSES_FAILURE = "FETCH_GROUPED_RESPONSES_FAILURE";

export const FETCH_PARAMETRESFORM_REQUEST = "FETCH_PARAMETRESFORM_REQUEST";
export const FETCH_PARAMETRESFORM_SUCCESS = "FETCH_PARAMETRESFORM_SUCCESS";
export const FETCH_PARAMETRESFORM_FAILURE = "FETCH_PARAMETRESFORM_FAILURE";

// 
export const CREATE_CONFIGURELIMITREPONSES_REQUEST = "CREATE_CONFIGURELIMITREPONSES_REQUEST";
export const CREATE_CONFIGURELIMITREPONSES_SUCCESS = "CREATE_CONFIGURELIMITREPONSES_SUCCESS";
export const CREATE_CONFIGURELIMITREPONSES_FAILURE = "CREATE_CONFIGURELIMITREPONSES_FAILURE";


export const CREATE_CONFIGUREEXPIRATIONREPONSES_REQUEST = "CREATE_CONFIGUREEXPIRATIONREPONSES_REQUEST";
export const CREATE_CONFIGUREEXPIRATIONREPONSES_SUCCESS = "CREATE_CONFIGUREEXPIRATIONREPONSES_SUCCESS";
export const CREATE_CONFIGUREEXPIRATIONREPONSES_FAILURE = "CREATE_CONFIGUREEXPIRATIONREPONSES_FAILURE";

export const DELETE_RESPONSEFORM_REQUEST = "DELETE_RESPONSEFORM_REQUEST";
export const DELETE_RESPONSEFORM_SUCCESS = "DELETE_RESPONSEFORM_SUCCESS";
export const DELETE_RESPONSEFORM_FAILURE = "DELETE_RESPONSEFORM_FAILURE";